// extracted by mini-css-extract-plugin
module.exports = {"question":"Quiz_question__Z4-Wj","hidden":"Quiz_hidden__3eH2k"};